<div class="tooltip" [ngStyle]="tooltipStyles">
  <ng-container *ngTemplateOutlet="tooltipContent" />
</div>

<ng-template #tooltipContent>
  @if (contentRef) {
    <ng-container *ngTemplateOutlet="contentRef" />
  } @else {
    {{ tooltip }}
  }
</ng-template>
